import {apiWithToken} from '../../../systems/api';
import {API_URL} from './../../../systems/globalContant';

export default {
    updateComplaintSellerSuccess: (datas) => {
        return apiWithToken.put(API_URL.UPDATE_COMPLAINT_DETAIL_SUCCESS.replace("{id}", datas.id), {...datas}, {loading: false})
    },
};
